
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationD as ObiLocationDElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-d.js';
 
 
 

 
 export const ObiLocationD = createComponent({
   react: React,
   tagName: 'obi-location-d',
   elementClass: ObiLocationDElement,
   events: {
     
   }
  });
 
 